import { NgClass, NgIf } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, signal, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardOption } from 'src/app/models/dashboard-option';

declare function generateChart(elementId: string, data: any, type: string): any;

@Component({
  selector: 'app-horizontal-dar-chart',
  imports: [NgIf, NgClass],
  templateUrl: './horizontal-dar-chart.component.html',
  styleUrl: './horizontal-dar-chart.component.css'
})
export class HorizontalDarChartComponent implements OnChanges {
  @Input() chartId!: string;
  @Input() icon!: string;
  @Input() title!: string;
  @Input() data!: DashboardOption[];
  @Input() series: string[] = [];

  @Input() isLoading: boolean = false;
  @Input() hasError: boolean = false;
  @Input() isNoData: boolean = false;

  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

  private chartInstance: any;

  colors: string[] = [
    'rgba(54, 162, 235, 0.5)', // blue
    'rgba(255, 99, 132, 0.5)', // red
    'rgba(255, 206, 86, 0.5)', // yellow
    'rgba(75, 192, 192, 0.5)', // green
    'rgba(153, 102, 255, 0.5)', // purple
    'rgba(255, 159, 64, 0.5)', // orange
    'rgba(178, 34, 34, 0.5)', // firebrick
    'rgba(255, 215, 0, 0.5)', // gold
    'rgba(46, 139, 87, 0.5)', // seagreen
    'rgba(0, 128, 128, 0.5)', // teal
  ];

    borderColors: string[] = [
    'rgba(54, 162, 235, 1)', // blue
    'rgba(255, 99, 132, 1)', // red
    'rgba(255, 206, 86, 1)', // yellow
    'rgba(75, 192, 192, 1)', // green
    'rgba(153, 102, 255, 1)', // purple
    'rgba(255, 159, 64, 1)', // orange
    'rgba(178, 34, 34, 1)', // firebrick
    'rgba(255, 215, 0, 1)', // gold
    'rgba(46, 139, 87, 1)', // seagreen
    'rgba(0, 128, 128, 1)', // teal
    // ... add many more colors
  ];


  labelsLength = signal<number>(0);

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      this.buildChart();
    }
  }

  private buildChart(): void {
    if (!this.data || this.data.length === 0) return;

    const labelsList = [...new Set(this.data.map(item => item.labelName))];
    this.labelsLength.set(labelsList.length); // Just assign the value

    if (this.series.length === 0) {
      this.series = [...new Set(this.data.map(item => item.serieName))];
    }

    const datasetList = this.series.map((serie, index) => {
      return {
        label: serie,
        backgroundColor: this.colors[index % this.colors.length], // Modulo for cycling colors
        borderColor: this.borderColors[index % this.borderColors.length], // Modulo for cycling colors
        borderWidth: 1,
        data: labelsList.map(label => {
          const item = this.data.find(d => d.labelName === label && d.serieName === serie);
          return item ? item.countValue : 0;
        })
      };
    });

    const horizontalBarChartData = {
      labels: labelsList,
      datasets: datasetList
    };

    const canvas = document.getElementById(this.chartId) as HTMLCanvasElement;
    if (canvas) {
      if (this.labelsLength() > 10) {  // Use the assigned value
        canvas.height = Math.max(436, this.labelsLength() * 10); // Increased height factor for better visibility
      }

      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = generateChart(this.chartId, horizontalBarChartData, 'horizontalBar');
    }
  }
}